module.exports = __webpack_public_path__ + "static/media/coffee-mugs.f61acefd.png";